// extracted by mini-css-extract-plugin
export var noSpinners = "_nw-6";
export var percentageInput = "_nw-7";
export var variantColor1 = "_nw-0";
export var variantColor2 = "_nw-1";
export var variantColor3 = "_nw-2";
export var variantColor4 = "_nw-3";
export var variantColor5 = "_nw-4";
export var variantColor6 = "_nw-5";